import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import 'leaflet/dist/leaflet.css';
import './index.css'

if (import.meta.env.VITE_RESET_STORAGE === '1' && !sessionStorage.getItem('__storage_reset__')) {
  localStorage.clear()
  sessionStorage.setItem('__storage_reset__', '1')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
